import React, { Component } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { configure } from 'mobx';
import { Provider } from 'mobx-react';
import Portal from '@shopee/chatbot-ui/rn/components/Modal/rn/portal';
import { routers, browserHistory } from '@/routes';
import { onErrorCount } from './utils/onError';
import { ThemeProvider, ShopeePrimaryTheme } from '@nebula/styles/theme';
import reporter from './utils/report';
import { ENTRY_POINT } from '@/types/entryPoints';
import '@/styles/common.scss';
import '@/styles/bank.scss';

// [live-chat-split-change]
/* strict mobx */
configure({ enforceActions: 'always', isolateGlobalState: true });

const ENTRY_OK_LABEL_MAP = {
  [ENTRY_POINT.mePage]: 'entry_me_ok',
  [ENTRY_POINT.helpCentre]: 'entry_helpcentre_ok',
  [ENTRY_POINT.sellingPage]: 'entry_selling_ok',
  [ENTRY_POINT.shippingPage]: 'entry_orderdetail_ok',
};

const ENTRY_TIMEOUT_LABEL_MAP = {
  [ENTRY_POINT.mePage]: 'entry_me_timeout',
  [ENTRY_POINT.helpCentre]: 'entry_helpcentre_timeout',
  [ENTRY_POINT.sellingPage]: 'entry_selling_timeout',
  [ENTRY_POINT.shippingPage]: 'entry_orderdetail_timeout',
};

export default class App extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    console.error(error);
    return { hasError: true, errMessage: error?.message };
  }

  componentDidCatch(error) {
    onErrorCount(error);
    // 你同样可以将错误日志上报给服务器
  }
  render() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const startTime = urlSearchParams.get('ts');
    const entry = urlSearchParams.get('from');

    if (startTime && ENTRY_OK_LABEL_MAP[ENTRY_POINT[entry]]) {
      const cost = Date.now() - Number(startTime);

      // 耗时超过 10 分钟为无效数据
      if (cost <= 0 || cost > 10 * 60 * 1000) {
        reporter.apiBatchReport({
          type: 'time',
          value: { label: ENTRY_TIMEOUT_LABEL_MAP[ENTRY_POINT[entry]], cost },
        });
        reporter.apiLog('Invalid page load time', { level: 'warn', cost });
      } else {
        reporter.apiBatchReport({
          type: 'time',
          value: { label: ENTRY_OK_LABEL_MAP[ENTRY_POINT[entry]], cost },
        });
      }
    }

    if (this.state.hasError) {
      return <h1>Some thing Wrong: {this.state.errMessage}</h1>;
    }

    const stores = this.props.stores || {};
    return (
      <ThemeProvider theme={ShopeePrimaryTheme}>
        <Provider {...stores}>
          <Portal.Host>
            <Router history={browserHistory}>
              <Switch>
                {routers.map((route, i) => {
                  return <Route key={i} exact path={route.path} component={route.component} />;
                })}
                {<div className="not-found-page">404 Not found</div>}
              </Switch>
            </Router>
          </Portal.Host>
        </Provider>
      </ThemeProvider>
    );
  }
}
